import { ROLES } from '../constants/actionTypes';

const initial = { items: [], capabilities: [], loading: false };

export default function rolesReducer(state = initial, action) {
  switch (action.type) {
    case ROLES.LIST_REQUEST: return { ...state, loading: true };
    case ROLES.LIST_SUCCESS: return { ...state, loading: false, items: action.payload };
    case ROLES.CAPS_SUCCESS: return { ...state, capabilities: action.payload };
    case ROLES.CREATE:       return { ...state, items: [action.payload, ...state.items] };
    case ROLES.UPDATE:       return { ...state, items: state.items.map(r => r._id === action.payload._id ? action.payload : r) };
    case ROLES.REMOVE:       return { ...state, items: state.items.filter(r => r._id !== action.payload) };
    default: return state;
  }
}
